import { __assign, __rest } from "tslib";
import React, { useContext } from 'react';
import { MobileContext } from '../../../Context';
import EditPcpLink from './EditPcpLink';
import PcpDownloadLink from './PcpDownloadLink';
import PcpButtonWithPopover from './PcpButtonWithPopover';
import FreeDownloadLink, { MobileFreeDownloadLink } from './FreeDownloadLink';
import { DownloadButtonMode } from './utils';
import DownloadButtonWithPopover from './DownloadButtonWithPopover';
var FreeAndPcpDownloadButton = function (_a) {
    var deviation = _a.deviation, _b = _a.deviation.extended, pcp = (_b === void 0 ? {} : _b).pcp, mode = _a.mode, buttonProps = __rest(_a, ["deviation", "deviation", "mode"]);
    var isMobile = useContext(MobileContext);
    if (isMobile) {
        var hasFreeDownload = mode === DownloadButtonMode.FREE ||
            mode === DownloadButtonMode.FREE_AND_PREMIUM;
        return hasFreeDownload ? (React.createElement(MobileFreeDownloadLink, __assign({ deviation: deviation }, buttonProps))) : null;
    }
    if (mode === DownloadButtonMode.FREE) {
        return React.createElement(FreeDownloadLink, __assign({ deviation: deviation }, buttonProps));
    }
    else if (mode === DownloadButtonMode.OWNER_PREMIUM) {
        return React.createElement(EditPcpLink, { deviation: deviation });
    }
    else if (mode === DownloadButtonMode.PREMIUM &&
        pcp &&
        pcp.hasUserPurchased) {
        return React.createElement(PcpDownloadLink, __assign({ deviation: deviation }, buttonProps));
    }
    else if (mode === DownloadButtonMode.FREE_AND_PREMIUM && pcp) {
        return React.createElement(DownloadButtonWithPopover, __assign({ deviation: deviation }, buttonProps));
    }
    // DownloadButtonMode.PREMIUM and not having purchased it
    return React.createElement(PcpButtonWithPopover, __assign({ deviation: deviation }, buttonProps));
};
FreeAndPcpDownloadButton.displayName = 'FreeAndPcpDownloadButton';
export default FreeAndPcpDownloadButton;
//# sourceMappingURL=FreeAndPcpDownloadButton.js.map